module.exports = __webpack_public_path__ + "static/img/global.5837efd7.svg";